import { Clock3, ShieldCheck, CreditCard, Building2, TrendingUp, Sparkles } from "lucide-react";

const ITEMS = [
    { icon: Clock3, text: "Aberto 24 horas, todos os dias" },
    { icon: ShieldCheck, text: "Acesso seguro por QR Code ou cartão" },
    { icon: CreditCard, text: "Pix, cartão e aproximação" },
    { icon: Building2, text: "Contêiner ou espaço cedido, em condomínios e empresas" },
    { icon: TrendingUp, text: "Zero custo para o condomínio" },
    { icon: Sparkles, text: "Seu mercado, dentro de casa." },
];

const Track = ({ hidden = false }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {ITEMS.map(({ icon: Icon, text }, i) => (
            <span
                key={i}
                className="inline-flex items-center gap-3 px-8 py-4 text-[#F7F4EC] font-extrabold text-sm sm:text-base uppercase tracking-wider whitespace-nowrap"
            >
                <Icon className="w-5 h-5 text-[#F1C75B] shrink-0" />
                {text}
                <span className="ml-10 w-2 h-2 rounded-full bg-[#F1C75B]/70" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="relative z-10 bg-[#F57A3A] border-y-2 border-[#1A231E] overflow-hidden"
        >
            <div className="flex w-max marquee-track">
                <Track />
                <Track hidden />
            </div>
        </div>
    );
}
